"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _actionUtils = require("../../../utils/actionUtils");
var _sceneLayer = require("../../../actions/sceneLayer");
function sceneLayersUpdated(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var notifyingDirector = _ref2.notifyingDirector,
    sceneLayers = _ref2.sceneLayers;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    dispatch((0, _sceneLayer.syncSceneLayers)(sceneLayers));
  }
}
var _default = exports["default"] = sceneLayersUpdated;